import {Component, OnInit} from '@angular/core';
import {InformationDataService} from "./InformationDataService";
import {Information} from "./information";
import {UrlBuilder} from "../url-builder/url.builder";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css']
})
export class InformationComponent implements OnInit {
  information: Information;
  private updateSubscription: Subscription | undefined;

  constructor(private informationDataService: InformationDataService) {
    this.information = new Information();
  }

  ngOnInit(): void {
    let url: UrlBuilder = new UrlBuilder();

      this.informationDataService.GetData().subscribe({
        next: information => {
          this.information = information;
          var fuseData: number = parseInt(this.information.fuse, 16);
          this.information.fuse12DC = (fuseData  & 0x1) ? true : false;
          this.information.fuse24DC = (fuseData  & 0x2) ? true : false;
          this.information.fuse24AC = (fuseData  & 0x4) ? true : false;
          this.information.fuse40DC = (fuseData  & 0x8) ? true : false;

          if(this.information.flStatus_pollQuality > 80)
            this.information.signalquality = "Good";
          else
            if(this.information.flStatus_pollQuality >= 30)
              this.information.signalquality = "Acceptable";
            else
              this.information.signalquality = "BAD";

//---          alert('We need to make a message if there is something wrong on finSaved.'  );

        }

      });
  }

}
